const rankingItems = [
  { title: '知名美食博主深夜醉酒直播全程翻车', tag: '爆', tagColor: 'bg-primary-500 text-white' },
  { title: '某顶流男星酒店密会神秘女子48小时未出', tag: '热', tagColor: 'bg-accent-500 text-white' },
  { title: '百万粉颜值博主素颜出镜引发大规模脱粉', tag: '新', tagColor: 'bg-foreground-800 text-white' },
  { title: '娱乐圈知名导演被曝片场霸凌新人演员', tag: '热', tagColor: 'bg-accent-500 text-white' },
  { title: '网红情侣\"甜蜜\"人设崩塌，双方互爆黑料', tag: '爆', tagColor: 'bg-primary-500 text-white' },
  { title: '某选秀冠军涉嫌数据造假，投票记录遭曝光', tag: '新', tagColor: 'bg-foreground-800 text-white' },
  { title: '深夜酒店走廊监控流出，多位艺人被拍', tag: '热', tagColor: 'bg-accent-500 text-white' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-950 mb-10 text-center">
          今日大赛热度榜
        </h2>
        <div className="flex flex-col">
          {rankingItems.map((item, idx) => (
            <div
              key={idx}
              className={`flex items-center gap-4 py-4 ${
                idx < rankingItems.length - 1 ? 'border-b border-background-300/60' : ''
              }`}
            >
              <span className="text-3xl md:text-4xl font-black text-primary-500 w-12 text-right shrink-0">
                {(idx + 1).toString().padStart(2, '0')}
              </span>
              <span className="flex-1 text-sm md:text-base font-medium text-foreground-800 leading-snug">
                {item.title}
              </span>
              <span className={`shrink-0 px-3 py-1 rounded-full text-xs font-semibold ${item.tagColor}`}>
                {item.tag}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}